export default __webpack_public_path__ + "static/media/thankyouBannerNewDesktop.a3759f57.png";